import { Avatar, MyLink } from '@scramble/ui';
import IconChevron from '@scramble/design-system/icons/chevron-right.svg?react';
import { UserMenuProps } from '@/AppLayout/types';
import s from './index.module.scss';

export const UserMenu = ({ user  }: UserMenuProps): JSX.Element => {
  return (
    <MyLink href={user.link} className={s.wrapper}>
      <div className={s.avatar}>
        <Avatar url={user.avatar} name={user.name} />
      </div>
      <div className={s.content}>
        <div className="f-body-sm f-500">{user.name}</div>
        <div className="f-body-sm">{user.id}</div>
      </div>
      <IconChevron className={s.chevron} />
    </MyLink>
  );
};
